// Small formatter utilities and enums used by the admin dashboard
export const MeetingStatus = {
  CONFIRMED: 'Confirmed',
  SCHEDULED: 'Scheduled'
};

export const formatCurrency = (amount) => {
  if (amount == null) return '-';
  try {
    const num = (typeof amount === 'number') ? amount : Number(amount);
    if (Number.isNaN(num)) return String(amount);
    // Format as Indian Rupees
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(num);
  } catch (e) {
    return String(amount);
  }
};

export const formatPercentage = (value) => {
  if (value == null) return '-';
  return `${value}%`;
};

export const formatDate = (date) => {
  if (!date) return '-';
  try {
    const d = (date instanceof Date) ? date : new Date(date);
    if (Number.isNaN(d.getTime())) return String(date);
    return d.toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch (e) {
    return String(date);
  }
};

export default {
  MeetingStatus,
  formatCurrency,
  formatPercentage,
  formatDate
};
